(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("survey-angular", [], factory);
	else if(typeof exports === 'object')
		exports["survey-angular"] = factory();
	else
		root["Survey"] = factory();
})(this, function() {
return 